export const firebaseConfig = {
  apiKey: "AIzaSyB7IB9w15mJ4sW_8p1TBTrKf1B_37NEmbA",
  authDomain: "pruforcepulseid.firebaseapp.com",
  projectId: "pruforcepulseid",
  storageBucket: "pruforcepulseid.firebasestorage.app",
  messagingSenderId: "939057055462",
  appId: "1:939057055462:web:d4a03c43228d2acdac9d27",
  measurementId: "G-1J7Q51960K"
};
